import { useLocalStorage, useProvider, useNavigation } from '~/Hooks';
import { useState } from 'react';

export const useHeader = () => {
  const { logout } = useLocalStorage();

  const { currentProvider } = useProvider();
  const { navigate } = useNavigation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleNavigation = (path: string) => {
    const replacedPath = path.replace(':domain', currentProvider?.domain || '');
    navigate(replacedPath);
  };

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return {
    logout,
    anchorEl,
    handleNavigation,
    handleProfileMenuOpen,
    handleMenuClose,
  };
};
